import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import FontSelectListItem from '../../shared/FontSelectListItem';

const TextFontListItem = (props) => {
    const { textElementFont, index, updateTextElement, searchGoogleFonts } = props;

    const onFontChange = (font, fontSource) => {
        updateTextElement(index, { font, fontSource });
    };

    return (
        <FontSelectListItem
            value={textElementFont}
            onChange={onFontChange}
            searchGoogleFonts={searchGoogleFonts}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { font: textElementFont } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return { textElementFont };
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTextElement: (index, properties) => dispatch(createActions.updateTextElement(index, properties)),
        searchGoogleFonts: (query, skip, take) => dispatch(createActions.searchGoogleFonts(query, skip, take))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextFontListItem);
